import { RouteConfig } from 'vue-router';

const Dangan = () => import('./views/dangan/dangan.vue');
const DanganDetail = () => import('./views/dangan-detail/dangan-detail.vue');
const MenzhenEdit = () => import('./views/dangan-detail/components/menzhen-edit/menzhen-edit.vue');
const EditMessage = () => import('./views/edit-message/edit-message.vue');


const routers: RouteConfig[] = [
    {
        path: 'dangan',
        component: Dangan,
    },
    {
        path: "dangan-detail",
        component: DanganDetail
    },
    {
        path: "dangan-menzhen-edit",
        component: MenzhenEdit
    },
    {
        path: "dangan-edit-message",
        component: EditMessage
    },
    {
        path: '',
        redirect: 'dangan'
    },

]
export default routers;
